import $root from '../../static/proto-bundle';

class UserBuider {

  createPutUsernameRequestBody(username) {
    const builder = $root.lookup('PutUsernameRequest');
    const payload = builder.create({
      username
    });
    return builder.encode(payload).finish();
  }

  createPutConferencePinRequestBody(pin) {
    const builder = $root.lookup('PutConferencePinRequest');
    const payload = builder.create({
      conferencePin: pin
    });
    return builder.encode(payload).finish();
  }

  decodePutConferencePinResponse(payload) {
    const container = $root.lookup('PutConferencePinResponse');
    return container.decode(new Uint8Array(payload));
  }

  decodePutUsernameResponse(payload) {
    const container = $root.lookup('PutUsernameResponse');
    return container.decode(new Uint8Array(payload));
  }

  decodeCurrentUserResponse(payload) {
    const container = $root.lookup('CurrentUserResponse');
    return container.decode(new Uint8Array(payload));
  }

  decodeHistoryResponse(payload) {
    const container = $root.lookup('HistoryResponse');
    return container.decode(new Uint8Array(payload));
  }

  decodeContactsResponse(payload) {
    const container = $root.lookup('ContactsResponse');
    return container.decode(new Uint8Array(payload));
  }

  decodeUserResponse(payload) {
    const container = $root.lookup('UserResponse');
    return container.decode(new Uint8Array(payload));
  }

  decodeBuyResponse(payload) {
    const container = $root.lookup('BuyResponse');
    return container.decode(new Uint8Array(payload));
  }
}

export default UserBuider;



// WEBPACK FOOTER //
// ./src/services/user-builder.service.js